import { combineReducers } from "redux";
import Reducer from "./initialvalor";

const initialState = { usuario: {}, estado: false };

function tasks(state = initialState, action: any) {
    switch (action.type) {
        case "SET_USER":
            return { ...state, usuario: action.usuario, estado: action.estado };
        default:
            return state
    }
}

export default combineReducers({
    tasks,
})
